export default __webpack_public_path__ + "static/media/Pink flare4.179bf0a6.jpg";